import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { Meteor } from 'meteor/meteor'

import './assets/css/index.css'
import 'react-toastify/dist/ReactToastify.css'
import 'cropperjs/dist/cropper.css'
import 'react-day-picker/lib/style.css'
import 'react-phone-number-input/style.css'
import 'react-credit-card/source/card.css'
import 'react-credit-card/source/card-types.css'

/*if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render')
  whyDidYouRender(React, {
    trackAllPureComponents: false,
  })
}*/

Meteor.startup(async () => {
  ReactDOM.render(<App />, document.getElementById('root'))
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
